module.exports = __webpack_public_path__ + "static/media/SL 4.e0208a9a.mp3";